import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';

import SurveyName from './FormFields/surveyName';
import SurveyLocation from './FormFields/customSurveyLocation';
import SurveyAdditionalOptions from './FormFields/surveyAdditionalOptions';

const SurveyEditForm = ({
  initialValues,
  onSubmit,
  addonActive,
  onCancel,
  socialMediasEnabled,
  socialReviewsEnabled,
  isLoading,
  editForm,
}) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    render={({ handleSubmit, form, submitting, values }) => (
      <form name="customSurveyEditForm" onSubmit={handleSubmit}>
        <Field name="defaultCustomTerms" component="input" hidden />
        <SurveyName />
        <SurveyLocation editForm={editForm} values={values} />
        <SurveyAdditionalOptions
          values={values}
          form={form}
          addonActive={addonActive}
          socialMediasEnabled={socialMediasEnabled}
          socialReviewsEnabled={socialReviewsEnabled}
          editForm={editForm}
        />
        <div className="buttons mt-3">
          <button
            type="submit"
            className="btn-add-new btn btn-secondary"
            disabled={
              submitting ||
              !values.customTerms ||
              values.customizeTerms ||
              isLoading
            }
          >
            Publish Survey
          </button>
          <button
            type="button"
            className="btn-add btn btn-light bg-transparent cursor-pointer"
            onClick={onCancel}
            disabled={submitting || isLoading}
          >
            Cancel
          </button>
        </div>
      </form>
    )}
  />
);

SurveyEditForm.propTypes = {
  initialValues: PropTypes.shape({
    customSurveyName: PropTypes.string,
  }).isRequired,
};

export default SurveyEditForm;



// WEBPACK FOOTER //
// ./src/components/customSurvey/EditForm.js